document.addEventListener("DOMContentLoaded", () => {
    const orderList = document.querySelectorAll('.js-delete-btn')
    let cnt = orderList.length

    orderList.forEach(order => {
        order.addEventListener('click', e => {
            const closeBtn = e.target;
            const hidingElement = closeBtn.closest('.table-emulate__row');
            const id = hidingElement.id;
            if (confirm('Удалить из плана на сегодня?')) {
                cnt--;
                BX.ajax.runComponentAction('main:repair', 'rmFromList', {
                    mode: 'ajax',
                    data: { id }
                })
                .then((response) => {
                    if (response.status === 'success') {
                        hidingElement.style.display = 'none';
                        if (!cnt) {
                            window.location.replace('/repair/')
                        }
                    } else {
                        console.log(response.errors)
                    }
                })
            }
        });
    });
});